<template>
  
    <div id="app">    
      <router-view v-if="isRouterAlive" />        
      <ConfirmDialog :modal="true"/>
      <div class="loading-view" :modal="true" v-if="loading">
        <div class="loading-box" v-if="loadingMessage !== ''">
          <div>
            <ProgressSpinner style="width:50px;height:50px; visibility: hidden;" strokeWidth="5"  />
            <p style="width: 100%;"><pre>{{ loadingMessage }}</pre></p>
          </div>
        </div>
      </div>
    </div>
    
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ConfirmDialog from 'primevue/confirmdialog';
import BlockUI from 'primevue/blockui';                    
import ProgressSpinner from 'primevue/progressspinner';

export default {
  data() {
    return {
      isRouterAlive: true,
      blockUIV: false,
    };
  },
  created() {
    window.getAppConfig = this.getAppConfig;
    window.getPaymentFeatureConfig = this.getPaymentFeatureConfig;
    window.setDefaultCarrier = this.setDefaultCarrier;
    window.handleActionError = this.handleActionError;
    this.getDeviceInformation();
  },
  components: {
    ConfirmDialog,
    BlockUI,
    ProgressSpinner,
  },
  mounted() {
    console.log(this.loading);
  },
  methods: {
    ...mapActions(['setSession', 'getDeviceInformation', 'setSupportFeatures', 'setDefaultCarrier']),
    getAppConfig(sessionKey, sessionToken, sessionTuitionPayment) {
      let query = { ...this.$route.query, k: sessionKey, p: sessionToken };

      if (sessionTuitionPayment === true || sessionTuitionPayment === 'true') {
        query.tuition_payment = sessionTuitionPayment;
        this.setSession({
          sessionKey: sessionKey,
          sessionToken: sessionToken,
          sessionTuitionPayment: sessionTuitionPayment,
        });
      } else {
        this.setSession({
          sessionKey: sessionKey,
          sessionToken: sessionToken,
        });
      }
    },
    getPaymentFeatureConfig(isShowFeature) {
      this.setSupportFeatures(isShowFeature);
    },

    handleActionError() {
      //alert('error: action not found');
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  computed: {
    ...mapGetters(['sessionToken', 'sessionKey', 'loading', 'loadingMessage']),
  },
  watch: {
    $route(to) {
      let payload = {};
      if (to.path === '/tax') {
        if (to.query.title !== null && to.query.title !== undefined) {
          sessionStorage.setItem('localtitle', to.query.title);
        }
        payload = { title: `${sessionStorage.getItem('localtitle')}地方稅`, headerType: to.meta.headerType };
      } else if (to.path !== '/tax') {
        payload = { title: to.name, headerType: to.meta.headerType };
      }
      this.$store.dispatch('sentApp', {
        action: 'configureAppWebPage',
        payload: payload,
      });
    },
    sessionToken(newVal) {
      if (newVal) {
        this.reload();
      }
    },
  },
};
</script>

<style scoped></style>
